import { makeStyles } from "@mui/styles";

export const actionsButtonsContainerSx = {
  display: "flex",
  gap: "8px",
  alignItems: "center",
  height: "100%",
};

export const listItemButtonStyles = (theme) => ({
  borderRadius: 1,
  height: "32px",
  width: "100%",
  justifyContent: "center",
  "&.Mui-selected": {
    backgroundColor: "#ffffff",
    color: "#000000",
    "& .MuiListItemIcon-root": {
      color: "#000000",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },
  "&:not(.Mui-selected):hover": {
    backgroundColor: `${theme.palette.primary.light} !important`,
  },
});

export const listItemIconStyles = (theme) => ({
  color: theme.palette.primary.contrastText,
  minWidth: "auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transition: "color 0.2s",
  "& .MuiSvgIcon-root": {
    fontSize: "14px",
    width: "14px",
    height: "14px",
  },
});

export const useDrawerStyles = makeStyles((theme) => ({
  drawer: {
    width: ({ isDrawerOpen }) => (isDrawerOpen ? "195px" : "73px"),
    flexShrink: 0,
    zIndex: 1,
    "& .MuiDrawer-paper": {
      width: ({ isDrawerOpen }) => (isDrawerOpen ? "195px" : "73px"),
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      transition: "width 0.2s",
      overflowX: "hidden",
      height: "100%",
    },
  },
  logoContainer: {
    width: "100%",
    display: "flex",
    paddingTop: theme.spacing("45px"),
    paddingBottom: theme.spacing("45px"),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    maxHeight: "19px",
    width: ({ isDrawerOpen }) => (isDrawerOpen ? "108px" : "30px"),
    transition: "width 0.2s",
  },
  bottomContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(7),
    paddingBottom: theme.spacing(7),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    alignItems: ({ isDrawerOpen }) => (isDrawerOpen ? "start" : "center"),
    justifyContent: ({ isDrawerOpen }) => (isDrawerOpen ? "start" : "center"),
  },
  version: {
    width: "100%",
    textAlign: "start",
    color: theme.palette.primary.contrastText,
    fontSize: "10px",
    marginTop: 1,
  },
}));

export const PaperStyles = (isMobile) => ({
  paddingY: 6,
  paddingX: isMobile ? "50px" : "200px",
  width: "100%",
  mt: isMobile ? 0 : 5,
});

export const TextFieldStyles = {
  "& .MuiFilledInput-root": {
    height: "50px",
    backgroundColor: "#E9EEF0",
  },
};

export const MobileMenuIconsStyles = {
  width: "24px",
  height: "24px",
  color: "black",
};

export const ButtonStyles = {
  minWidth: "142px",
  width: "fit-content",
  height: "40px",
  textTransform: "none",
  borderRadius: "2px",
};

export const StepperStyles = {
  "& .MuiStepIcon-root": {
    fontSize: "40px",
  },
  "& .MuiStepLabel-label": {
    fontSize: "14px",
    fontWeight: "bold",
  },
  "& .MuiStepConnector-root": {
    marginLeft: "20px",
  },
  "& .MuiStepConnector-line": {
    height: "100%",
  },
};

export const iconContainerStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: "#CDCED2",
  p: 1,
  borderRadius: "50%",
};

export const clusterDivStyle = `
              background-color: rgba(0, 200, 255, 1);
              color: white;
              border-radius: 50%;
              width: 100%;
              text-align: center;
              font-weight: bold;
              font-size: 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
            `;

export const sensorIconStyle = (bgColor) => ({
  p: 1,
  minWidth: "53px",
  minHeight: "53px",
  bgcolor: bgColor,
  borderRadius: "50px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
});

export const sensorBoxStyle = () => ({
  width: "100%",
  height: "100%",
  maxHeight: "68px",
  bgcolor: "white",
  display: "flex",
  justifyContent: "start",
  p: 1,
  gap: 1,
  cursor: "pointer",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: 2,
  },
  opacity: 1,
});

export const sensorChartButtonStyle = () => ({
  width: "36px",
  height: "36px",
  minWidth: "36px",
  textTransform: "none",
});

export const authPageContainerStyles = (theme) => ({
  width: "100vw",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.custom.backgroundColor,
});

export const authPaperStyles = {
  width: "512px",
  height: "388px",
  backgroundColor: "#ffffff",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  p: 7,
};

export const authTitleStyles = {
  fontWeight: 600,
  fontSize: "10px",
  color: "primary.main",
};

export const authLogoStyles = {
  width: "177.69px",
  height: "30.6px",
  mb: 4,
};

export const typeColor = {
  DISEASE_REPORT: "#DA2F2F",
  SIMPLE_NOTE: "#4A6CDC",
};
